export enum SupplierOrderBy {
  id = 'id',
  createdAt = 'createdAt',
  fullname = 'fullname',
  fiscalNumber = 'fiscalNumber'
}
